export enum ScreenType {
  phone = 'phone',
  tablet = 'tablet',
  desktop = 'desktop'
}
